import city1 from '../img/city/city1.jpg';
import city2 from '../img/city/city2.jpg';
import city3 from '../img/city/city3.jpg';
import seoul from '../img/seoul.jpg';

export default {
  arc_istanbul: {
    image: city3,
    name: 'Architecture in  Istanbul',
    location: 'Istanbul, Turkey',
    date: 'Oct. 2 - 5th',
  },
  mem_istanbul: {
    image: city1,
    name: 'Memories of  Istanbul',
    location: 'Istanbul, Turkey',
    date: 'Jun. 14 - 21th',
  },
  arc2_istanbul: {
    image: city2,
    name: 'Architecture in  Istanbul 2',
    location: 'Istanbul, Turkey',
    date: 'Jan. 27 - 31st',
  },
  seoul: {
    image: seoul,
    name: 'Weekend Getaway to Seoul',
    location: 'Seoul, South Korea',
    date: 'Nov. 15 - 17th',
  },
};
